<template>
  <div v-if="visible" class="dialog-box">
    <div class="mask"></div>
    <div
      class="dialog dialog-primary"
      ref="dialogRef"
      :style="`top:${top}px;left:${left}px;width:${
        width ? `${width}px` : '600px'
      }`"
    >
      <div class="dialog-header" @mousedown="handleDragStart">
        <span>{{ title }}</span>
        <span class="icon dialog-header-icon" @click="closeDialog"
          ><i class="el-icon-close"></i
        ></span>
      </div>
      <div class="dialog-content"><slot></slot></div>
      <div class="dialog-footer" v-if="footerBtn.length">
        <el-button
          v-if="footerBtn.includes('cancel')"
          size="small"
          class="negative hollowOut-btn primary-ang-btn"
          @click="closeDialog"
          >取 消</el-button
        >
        <el-button
          v-if="footerBtn.includes('submit')"
          size="small"
          class="positive primary-btn gl8 primary-ang-btn"
          @click="ok"
          >确定</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DragDialog",
  data() {
    return {
      top: 50,
      left: 360,
    };
  },
  props: {
    title: String,
    visible: Boolean,
    footerBtn: Array,
    width: Number,
    defaultTop: Number,
    defaultLeft: Number,
    submit: Function,
    cancel: Function,
  },
  created() {
    this.top = this.defaultTop ? this.defaultTop : 50;
    this.left = this.defaultLeft ? this.defaultLeft : 360;
  },
  mounted() {
    document.addEventListener("mousemove", this.onMouseMove);
    document.addEventListener("mouseup", this.onMouseUp);

    document.addEventListener("keydown", this.onEnterDown);
  },
  beforeDestroy() {
    document.removeEventListener("mousemove", this.onMouseMove);
    document.removeEventListener("mouseup", this.onMouseUp);

    document.removeEventListener("keydown", this.onEnterDown);
  },
  methods: {
    onEnterDown(event) {
      // 防止正常输入框过滤触发事件
      let form = event.srcElement.form;
      if (!form) return;

      if (event.keyCode === 13) {
        if (this.submit) {
          this.submit();
        }
      }
    },
    closeDialog(e) {
      if (this.cancel) {
        this.cancel();
      }
    },
    ok(e) {
      e.preventDefault();
      if (this.submit) {
        this.submit();
      }
    },
    handleDragStart(e) {
      e.target.style.cursor = "move";
      this.originTop = e.target.offsetParent.offsetTop;
      this.originLeft = e.target.offsetParent.offsetLeft;
      this.originX = e.clientX;
      this.originY = e.clientY;
      this.isMouseDown = true;
    },
    onMouseMove(event) {
      if (!this.isMouseDown) return false;
      let deltaX = event.clientX - this.originX;
      let deltaY = event.clientY - this.originY;
      let activeElement = document.activeElement;
      let maxLeft =
        activeElement.offsetWidth - this.$refs.dialogRef.offsetWidth;
      let maxTop =
        activeElement.offsetHeight - this.$refs.dialogRef.offsetHeight;
      let top = deltaY + this.originTop;
      let left = deltaX + this.originLeft;
      if (left > maxLeft) return false;
      if (top > maxTop) return false;
      if (top <= 0) return false;
      if (left <= 0) return false;
      this.top = top;
      this.left = left;
    },
    onMouseUp(e) {
      if (!this.isMouseDown) return false;
      this.isMouseDown = false;
      e.target.style.cursor = "default";
    },
  },
};
</script>

<style lang="less" scoped>
.dialog-box {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  z-index: 3;

  .mask {
    position: absolute;
    width: 100%;
    height: 100%;
    background: var(--dialog-mask-bgColor);
  }

  .dialog {
    position: absolute;
    top: 25%;
    left: 40%;
    border-radius: 16px;
    // min-height: 600px;
    background: var(--dialog-bgColor);

    .dialog-header {
      display: flex;
      justify-content: space-between;
      height: 45px;
      padding: 10px 20px;
      color: var(--dialog-header-text-color);
      background: var(--dialog-header-bgColor);

      .icon {
        display: flex;
        cursor: pointer;
        padding: 5px;
      }
    }

    .dialog-content {
      height: calc(100% - 98px);
      padding: 16px;
    }

    .dialog-footer {
      width: 100%;
      text-align: right;
      border-top: 1px solid var(--dialog-footer-border-color);
      justify-content: flex-end;
    }
  }
}
</style>
